import { stateNameMap } from '@/Modules/Grafer/common/stateMappings';

const mappedStates = Object.values(stateNameMap);

export const PieData = mappedStates.map(stateName => ({
  name: stateName,
  value: 0
}));

export function MakePieData(jobs) {
  PieData.forEach(item => (item.value = 0));

  jobs.forEach(job => {
    const mappedState = stateNameMap[job.state] || job.state;
    const pieItem = PieData.find(item => item.name === mappedState);
    if (pieItem) {
      pieItem.value++;
    }
  });

  return PieData.filter(item => item.value > 0);
}

export function MakeHostPieData(jobs) {
  const hostCounts = {};

  jobs.forEach(job => {
    const host = job.hostMachineName || 'Unknown';
    hostCounts[host] = (hostCounts[host] || 0) + 1;
  });

  return Object.keys(hostCounts).map(host => ({
    name: host,
    value: hostCounts[host]
  }));
}

export function extractUniqueHosts(jobs) {
  const seen = new Set();
  let hasUnknown = false;

  jobs.forEach(job => {
    if (job.hostMachineName) {
      seen.add(job.hostMachineName);
    } else {
      hasUnknown = true;
    }
  });

  const hosts = Array.from(seen);
  if (hasUnknown) hosts.push('Unknown');
  return hosts;
}
